import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { initSentry, SentryErrorBoundary } from './sentry'
import { initGA4 } from './ga4'
import './index.css'
import App from './App.jsx'

// Initialize Sentry and GA4 before rendering
initSentry();
initGA4();

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <SentryErrorBoundary
      fallback={({ resetError }) => (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          padding: '2rem',
          textAlign: 'center',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white'
        }}>
          <h1 style={{ fontSize: '2rem', marginBottom: '1rem' }}>⚠️ Algo salió mal</h1>
          <p style={{ marginBottom: '2rem', opacity: 0.9 }}>
            El error ha sido reportado automáticamente. Estamos trabajando en solucionarlo.
          </p>
          <button
            onClick={resetError}
            style={{
              padding: '0.75rem 2rem',
              background: 'white',
              color: '#667eea',
              border: 'none',
              borderRadius: '8px',
              fontSize: '1rem',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
            🔄 Reintentar
          </button>
        </div>
      )}
    >
      <HelmetProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </HelmetProvider>
    </SentryErrorBoundary>
  </StrictMode>,
)
